import { parseInt } from 'lodash';

import getNumbers from './getNumbers';

export default value => parseInt(getNumbers(value));
